const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/

export function parseDatePreservingCalendarDay(value) {
  if (!value) return null

  if (value instanceof Date) {
    return value
  }

  if (typeof value === 'string' && DATE_ONLY_PATTERN.test(value)) {
    const [year, month, day] = value.split('-').map(Number)
    return new Date(year, month - 1, day)
  }

  return new Date(value)
}

export function formatDateForDisplay(value) {
  const date = parseDatePreservingCalendarDay(value)
  if (!date || Number.isNaN(date.getTime())) return '—'
  return date.toLocaleDateString()
}

export function getLocalDateInputValue(date = new Date()) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
